var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
;

var SvgBubble = function SvgBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMaxYMin meet",
    viewBox: "0 0 650.22 449.58"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bubble_svg__bubble_svg__bubble-top",
    x1: -709.58,
    x2: -709.58,
    y1: -591.8,
    y2: -169.55,
    gradientTransform: "translate(982.18 588.86) scale(.98735)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#bubble_svg__bubble_svg__bubble"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bubble_svg__bubble_svg__bubble"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "bubble_svg__bubble_svg__gradient-primary-start",
    offset: 0,
    stopColor: "#6346bd"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "bubble_svg__bubble_svg__gradient-primary-stop",
    offset: 1,
    stopColor: "#333b8c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bubble_svg__bubble_svg__bubble-bottom",
    x1: -709.58,
    x2: -709.58,
    y1: -591.8,
    y2: -169.55,
    gradientTransform: "rotate(-10.033 3189.614 -5737.557) scale(.98735)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#bubble_svg__bubble_svg__bubble"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bubble_svg__bubble_svg__bubble-top)",
    d: "M45.052 101.9c129.25-132 493.57-135.23 590.14 23.611 81.36 148.63-186.75 237.38-347.05 292.27-67.935 23.261-159.5 56.539-207.49 3.132-73.02-90.401-94.915-255.13-35.591-319.01z",
    opacity: 0.66
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bubble_svg__bubble_svg__bubble-bottom)",
    d: "M57.975 53.589c150.27-107.46 509.58-47.168 577 126.07 54.22 160.54-225.25 201.21-392.67 227.33-70.948 11.069-166.91 27.886-204.87-33.067-56.153-101.74-49.013-267.76 20.533-320.33z"
  })));
};

;
export default SvgBubble;